<template>
  <div
    v-if="activity"
    class="p-2"
    @click="onClickPanel">
    <div class="search__company">
      <span class="search__lead">活動</span>
      <h2 
        class="search__company-heading d-flex mb-2 justify-content-between align-items-center"
        :class="activityMarkClass">
        {{ activity.name }}
        <span class="search__time">
          {{ activity.workAt | prettyDateTime }}
        </span>
      </h2>
    </div>
    <div class="search__detail p-2">
      <h3 class="search__detail-heading mb-2">
        活動記録
      </h3>
      <div class="search__text">
        <p>{{ activity.detail }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activity: {
      type: Object,
      default: null
    },
    goal: {
      type: Object,
      default: null
    }
  },
  computed: {
    activityMarkClass() {
      if (!this.activity) return ''
      if (this.activity.star) return 'search__company-heading--marked'
      return 'search__company-heading'
    }
  },
  methods: {
    onClickPanel() {
      const decoded = decodeURIComponent(`/members/${this.goal.createdBy.id}?goalId=${this.goal.id}&activityId=${this.activity.id}&goalEndDate=${this.goal.endDate}`)
      this.$router.push(decoded)
    }
  }
}
</script>

<style lang="scss" scoped>
.search{
  &__lead{
    font-size: $fs-s;
    color: $grey08;
    display: block;
    font-weight: normal;
  }
  &__company{
    font-size: $fs-nm;
    font-weight: bold;
  }
  &__company-heading{
    font-size: $fs-nm;
    font-weight: bold;
    position: relative;
    padding-left: 16px;
    &:before{
      content: "";
      position: absolute;
      background: $grey16;
      top: 4px;
      left: 0;
      height: 12px;
      width: 12px;
      border-radius: 50%;
    }
    &--marked{
      &:before{
        background: $pink;
      }
    }
  }
  &__detail{
    background-color: $grey07;
    border-radius: 1px;
  }
  &__detail-heading{
    font-size: $fs-nm;
    font-weight: bold;
  }
  &__time{
    color: $grey08;
    font-size: $fs-s;
    font-weight: normal;
  }
  &__text{
    white-space:pre-wrap;
    word-wrap:break-word; 
    color: $grey04;
    font-size: $fs-nm;
  }
}
</style>